<template>
  <div class="container d-flex align-items-center justify-content-center vh-100">
    <div class="alert alert-info text-center" role="alert" style="font-size: 1.5em;">
      Actualmente estamos verificando tu información, para acceder a las funciones del sistema.
    </div>
  </div>
</template>


<script>
export default {
  name: 'Bienvenida',
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    if (!this.currentUser || !this.currentUser.roles.includes('ROLE_USUARIO'))  {
      this.$router.push('/login');
    }
  }
};
</script>